import { Flatten, KeyValue } from '@/types';

export const deepFind = <T extends KeyValue>(object: T, path: keyof Flatten<T>): any => {
  const paths = (path as string).split('.');
  let current = object;
  let i;

  for (i = 0; i < paths.length; ++i) {
    if (current[paths[i]] === undefined) {
      return undefined;
    }
    current = current[paths[i]];
  }

  return current;
};
